import { formatCash } from '../../../../utils/tableHelpers';

import styles from './RentCollectionCardDetails.module.scss';

const RentCollectionCardDetails = ({ payload }: any) => {
  const cardDetails = [
    { id: 1, headText: 'Total Rent Paid', subText: `C$${formatCash(payload?.totalRentPaid)}` },
    { id: 2, headText: 'Total Rent Settled', subText: `C$${formatCash(payload?.totalRentSettled)}` },
    { id: 3, headText: 'Total Rent Awaiting Settlement', subText: `C$${formatCash(payload?.totalAwaitingSettlement)}` },
    { id: 4, headText: 'Total Rent Refunded', subText: `C$${formatCash(payload?.totalRentRefunded)}` },
  ];

  return (
    <div className={styles?.wrapper}>
      {cardDetails?.map(({ id, headText, subText }) => (
        <div key={id} className={styles?.wrapper__card}>
          <h6 className={styles?.wrapper__headText}>{headText}</h6>
          <h2 className={styles?.wrapper__subText}>{subText}</h2>
        </div>
      ))}
    </div>
  );
};

export default RentCollectionCardDetails;
